import { render, staticRenderFns } from "./fee-budget-list.vue?vue&type=template&id=006c5226&"
import script from "./fee-budget-list.vue?vue&type=script&lang=ts&"
export * from "./fee-budget-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports